<template>
  <templateAdminComponent v-if="isUserAuthenticated()">
    <div>
      <h2>Rapports</h2>
      <div style="margin-top:15px;">
        <button class="btn btn-primary" v-bind:disabled="isWorkInProgress()" @click="$router.open({name: 'AdminContracts', params: {}})()">Générer contrats</button>
        <img src="@/assets/img/loading2.gif" width="25" style="margin-left:10px;" v-show="isWorkInProgress()" />
      </div>
      <div style="margin-top:15px;">
        <button class="btn btn-primary" v-bind:disabled="isWorkInProgress()" @click="generatePoleToInstallExcel()">Générer liste des poteaux à installer</button>
        <img src="@/assets/img/loading2.gif" width="25" style="margin-left:10px;" v-show="isWorkInProgress()" />
      </div>
      <div style="margin-top:15px;">
        <button class="btn btn-primary" v-bind:disabled="isWorkInProgress()" @click="generateCustomerSnowRemovalExcel()">Générer liste des clients à déneiger</button>
        <img src="@/assets/img/loading2.gif" width="25" style="margin-left:10px;" v-show="isWorkInProgress()" />
      </div>
      <div style="margin-top:15px;">
        <button class="btn btn-primary" v-bind:disabled="isWorkInProgress()" @click="generateCustomerNotRenewExcel()">Générer liste des clients non renouvelés</button>
        <img src="@/assets/img/loading2.gif" width="25" style="margin-left:10px;" v-show="isWorkInProgress()" />
      </div>
      <div style="margin-top:15px;">
        <button class="btn btn-primary" v-bind:disabled="isWorkInProgress()" @click="generateCustomerIncompletePaymentsExcel()">Générer liste des clients avec paiements incomplets</button>
        <img src="@/assets/img/loading2.gif" width="25" style="margin-left:10px;" v-show="isWorkInProgress()" />
      </div>
      <div style="margin-top:15px;">
        <button class="btn btn-primary" v-bind:disabled="isWorkInProgress()" @click="generateCustomerPaidNoPoleExcel()">Générer liste clients payés sans poteau</button>
        <img src="@/assets/img/loading2.gif" width="25" style="margin-left:10px;" v-show="isWorkInProgress()" />
      </div>
      <div style="margin-top:15px;">
        <button class="btn btn-primary" v-bind:disabled="isWorkInProgress()" @click="generateCustomerTotalByStreetExcel()">Générer liste des revenus par rue</button>
        <img src="@/assets/img/loading2.gif" width="25" style="margin-left:10px;" v-show="isWorkInProgress()" />
      </div>
      <div style="margin-top:15px;">
        <button class="btn btn-primary" v-bind:disabled="isWorkInProgress()" @click="generateCustomerBaseExcel()">Générer liste de base des clients</button>
        <img src="@/assets/img/loading2.gif" width="25" style="margin-left:10px;" v-show="isWorkInProgress()" />
      </div>
      <div style="margin-top:15px;">
        <ModalReportPhoneNotes v-model="dialogModalReportPhoneNotes"></ModalReportPhoneNotes>
        <button class="btn btn-primary" v-bind:disabled="isWorkInProgress()" @click="generatePhoneNotesExcel()">Générer rapport des notes téléphoniques</button>
        <img src="@/assets/img/loading2.gif" width="25" style="margin-left:10px;" v-show="isWorkInProgress()" />
      </div>
      <div style="margin-top:15px;">
        <ModalReportTransferInteract v-model="dialogModalReportTransferInteract"></ModalReportTransferInteract>
        <button class="btn btn-primary" v-bind:disabled="isWorkInProgress()" @click="generateTransferInteractExcel()">Générer rapport des virements interact</button>
        <img src="@/assets/img/loading2.gif" width="25" style="margin-left:10px;" v-show="isWorkInProgress()" />
      </div>
      <div style="margin-top:15px;">
        <ModalReportTransferBNC v-model="dialogModalReportTransferBNC"></ModalReportTransferBNC>
        <button class="btn btn-primary" v-bind:disabled="isWorkInProgress()" @click="generatePaymentsBNCExcel()">Générer rapport des télévirements BNC</button>
        <img src="@/assets/img/loading2.gif" width="25" style="margin-left:10px;" v-show="isWorkInProgress()" />
      </div>
    </div>
  </templateAdminComponent>
</template>

<script>
import auth from '@/auth'
import TemplateAdminComponent from '@/components/TemplateAdmin.vue'
import ModalPrintContracts from '@/components/ModalPrintContracts.vue'
import ModalReportPhoneNotes from '@/components/ModalReportPhoneNotes.vue'
import ModalReportTransferInteract from '@/components/ModalReportTransferInteract.vue'
import ModalReportTransferBNC from '@/components/ModalReportTransferBNC.vue'
import APIReport from '@/api/report'
const APIService = new APIReport();

export default {
  components:
  {
    TemplateAdminComponent,
    ModalPrintContracts,
    ModalReportPhoneNotes,
    ModalReportTransferInteract,
    ModalReportTransferBNC
  },

  data() {
    return {
      workInProgress: false,
      dialogContract: false,
      dialogModalReportPhoneNotes: false,
      dialogModalReportTransferInteract: false,
      dialogModalReportTransferBNC: false,
      ContractID: -1
    }
  },

  methods: {
    isUserAuthenticated() {
      return auth.isUserAuthenticated()
    },

    isWorkInProgress() {
        return this.workInProgress
    },

    async generatePoleToInstallExcel() {
      this.workInProgress = true
      await APIService.generatePoleToInstallExcel().then(response =>  {
          this.workInProgress = false
        }
      )
    },

    async generateCustomerPaidNoPoleExcel() {
      this.workInProgress = true
      await APIService.generateCustomerPaidNoPoleExcel().then(response =>  {
          this.workInProgress = false
        }
      )
    },

    async generateCustomerSnowRemovalExcel() {
      this.workInProgress = true
      await APIService.generateCustomerSnowRemovalExcel().then(response =>  {
          this.workInProgress = false
        }
      )
    },

    async generateCustomerNotRenewExcel() {
      this.workInProgress = true
      await APIService.generateCustomerNotRenewExcel().then(response =>  {
          this.workInProgress = false
        }
      )
    },

    async generateCustomerIncompletePaymentsExcel() {
      this.workInProgress = true
      await APIService.generateCustomerIncompletePaymentsExcel().then(response =>  {
          this.workInProgress = false
        }
      )
    },

    async generateCustomerBaseExcel() {
      this.workInProgress = true
      await APIService.generateCustomerBaseExcel().then(response =>  {
          this.workInProgress = false
        }
      )
    },

    async generateCustomerTotalByStreetExcel() {
      this.workInProgress = true
      await APIService.generateCustomerTotalByStreetExcel().then(response =>  {
          this.workInProgress = false
        }
      )
    },

    async generatePhoneNotesExcel() {
      // this.workInProgress = true
      // await APIService.generatePhoneNotesExcel().then(response =>  {
      //     this.workInProgress = false
      //   }
      // )

      this.dialogModalReportPhoneNotes = true
      this.dialogModalReportTransferInteract = false
      this.dialogModalReportTransferBNC = false
    },

    async generateTransferInteractExcel() {
      this.dialogModalReportPhoneNotes = false
      this.dialogModalReportTransferInteract = true
      this.dialogModalReportTransferBNC = false
    },

    async generatePaymentsBNCExcel() {
      this.dialogModalReportPhoneNotes = false
      this.dialogModalReportTransferInteract = false
      this.dialogModalReportTransferBNC = true
    }

  }
}
</script>






// WEBPACK FOOTER //
// src/views/admin/Rapports.vue